import type { StatLimits, UltimateRequirement } from "../../types";

export const limits: StatLimits = {
  baseHp: 3,
  maxHp: 8,
  baseMp: 1,
  maxMp: 8,
  baseWealth: 1,
  maxWealthFromSkills: 4,
  darkOfferingsLimit: 8,
  initialSkillPoints: 3,
  maxSpellLevel: 8,
  ultimateWarlock: { hp: 13, mp: 13, wealthLevel: 5 },
};

export const ultimateRequirement: UltimateRequirement = {
  kind: "gifts",
  description: "Currently hold a Gift from each Patron",
};
